import { Button, Grid } from "@mui/material";
import facebook from "assets/social/face-book.png";
import google from "assets/social/google.png";
import SocialButton from "components/buttons/SocialButton";
import CustomImage from "components/CustomImage";
import CustomLink from "components/CustomLink";
import CustomText from "components/typography/CustomText";
import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { openLoading } from "store/reducers/tools";
import RegisterForm from "./RegisterForm";

export default function RegisterComponent() {
  const history = useHistory();
  const formRef = useRef();
  const [data, setData] = useState({});

  const handleSubmit = () => {
    const submitData = formRef.current.prepare();
    if (submitData) {
      openLoading(true);
      setTimeout(() => {
        openLoading(false);
        handleFinish();
      }, 3000);
    }
  };

  const handleFinish = () => {
    history.push("/");
  };

  return (
    <div>
      <Grid container spacing={2} direction="column">
        <Grid item>
          <RegisterForm
            ref={formRef}
            data={data ?? {}}
            onChange={setData}
            type="state"
          />
        </Grid>
        <Grid item>
          <Button
            onClick={handleSubmit}
            variant="contained"
            size="large"
            fullWidth
          >
            Sign up
          </Button>
        </Grid>
        <Grid item>
          <CustomText variant="body2" align="center" italic>
            or sign up with
          </CustomText>
        </Grid>
        <Grid item>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item>
              <SocialButton>
                <CustomImage src={google} alt="google" />
              </SocialButton>
            </Grid>
            <Grid item>
              <SocialButton>
                <CustomImage src={facebook} alt="facebook" />
              </SocialButton>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={1}
          >
            <Grid item>
              <CustomText>Already have an account?</CustomText>
            </Grid>
            <Grid item>
              <CustomLink to="/" color="primary">
                Login!
              </CustomLink>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={1}
          >
            <Grid item>
              <CustomText variant="caption">
                By creating an account, you agree with our
              </CustomText>
            </Grid>
            <Grid item>
              <CustomLink color="primary" textVariant="caption">
                terms of service
              </CustomLink>
            </Grid>
            <Grid item>
              <CustomText variant="caption">and</CustomText>
            </Grid>
            <Grid item>
              <CustomLink color="primary" textVariant="caption">
                privacy
              </CustomLink>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
